export const PdClientTypes = {
  Cognito: "cognito",
  Azure: "azure"
};
